module.exports = __webpack_public_path__ + "img/banner-supplies-mapgrafi.c86aa119.jpg";